export default __webpack_public_path__ + "static/media/LinkedIn Learning JavaScript Essential Training 2021.1d9559cf.webp";